import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// material-ui icons
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
// core components
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Footer from "components/Footer/Footer.jsx";

import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.jsx";
import styles from "assets/jss/customStyle.jsx";
import classNames from "classnames";

import NavigationBar from "../../components/inc/NavigationBar.jsx";
import Clearfix from "../../components/Clearfix/Clearfix.jsx";
// import StepWizard from "../../components/StepWizard/StepWizard.jsx";
import projectListPageStyle from "../../assets/jss/projectListPageStyle.jsx";
import { getMyBidSprintList } from "../../actions/myBids";
import connect from "react-redux/es/connect/connect";
import LoadingComponent from "../../components/inc/LoadingComponent.jsx";
import PageTitle from "../../components/inc/PageTitle.jsx";
import { Link } from "react-router-dom";
import MainPage from "assets/jss/MainPageStyle.jsx";
import Moment from "react-moment";

class MySprint extends React.Component {

  componentDidMount() {
      this.props.loadSprintList(this.props.match.params.id);
  }

  render() {
    const { classes, sprints, isFetching, history } = this.props;
    const { projectTitle } = this.props.location.state;
    let tableData = []

    const newTableData = sprints.map(
      (val, i) => {
        let newArr = [];
        newArr.push(i+1);
        newArr.push(
          <Link 
            to={{
                pathname: `/mybid/projects/${val.project}/sprints/${val._id}/stories`,
                state: {
                  projectTitle: projectTitle,
                  sprintTitle: val.title,
                }
            }}
          >
              {val.title}
          </Link>
        );
        newArr.push(val.sprintStatus.status);
        newArr.push(
          <Moment format="D MMM YYYY HH:MM:SS" withTitle>
            {val.updatedAt}
        </Moment>
        );
        return newArr;
      });

    return (
      <div>
        <div style={styles.removePadding}>
          <NavigationBar />
        </div>

        <div className={classNames(classes.main)}>
          <div style={styles.projectListSection}>
            <PageTitle title={projectTitle}  />
            <LoadingComponent isLoading={ isFetching }>
              <Table
                striped
                tableHead={["#", "Sprint Title", "Sprint Status", "Last Bid"]}
                tableData={newTableData}
                customCellClasses={[
                  classes.textCenter,
                  classes.textRight,
                  classes.textRight,
                  classes.textRight
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.textCenter,
                  classes.textRight,
                  classes.textRight,
                  classes.textRight
                ]}
                customHeadClassesForCells={[0, 4, 5]}
              />
            </LoadingComponent>
            <Clearfix />
            <div className={classes.left} style={styles.marginTopBottom}>
              <Link to={`/admin/dashboard/bids/projects`}>
                <Button type="button" color="success" round>
                  Back
                </Button>
              </Link>
            </div>
          </div>
          <Clearfix />
        </div>
        <Footer
          theme="#e5e5e5"
          content={
            <div>
              <div className={classes.right}>
                A &copy;&nbsp;
                <a href="http://www.root-nyc.com">Root NYC</a>
                &nbsp;Product
              </div>
            </div>
          }
        />
        {/*/!*<LoadingComponent isLoading={isFetching}>*!/*/}

        {/*</LoadingComponent>*/}
      </div>
    );
  }
}

const mapStateToProps = state => ({
      isFetching: state.myBid.isFetching,
      sprints: state.myBid.sprints ? state.myBid.sprints:  []
});

const mapDispatchToProps = dispatch => ({
  loadSprintList: projectId => dispatch(getMyBidSprintList(projectId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(MainPage)(MySprint));
